<template>
  <section class="page-wrap" :class="[wrapClass ? wrapClass : '']">
    <div v-html="htmlDesc"></div>
  </section>
</template>

<script>
export default {
  name: 'DangerView',
  props: {
    wrapClass: { type: String, default: '' },
    htmlDesc: {
      type: String,
      default: `
        <div style="font-size: 14px;color: #333333; line-height: 1.5">
				<h1 style="text-align: center">
					<span style="font-family: 宋体; font-weight: normal; font-size: 22px">用户服务协议</span>
				</h1>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">一、重要提示</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						><span style="font-family: 宋体">请您（以下亦称</span
						><span style="font-family: 宋体"
							>“用户”）在使用开放云书院平台（以下亦称“我们”）服务或在申请注册流程前仔细阅读《开放云书院用户服务协议》（以下简称“本协议”）之全部条款，并在确认您已完全理解本协议之规定，尤其是涉及您的重大权益、义务履行以及免责说明的加粗或划线条款后，使用我们提供的服务。如您对协议有任何疑问，请立即停止使用开放云书院平台服务及注册平台用户，并可向平台客服咨询。</span
						></span
					>
				</p>
				<p style="text-indent: 28px"><span style="font-family: 宋体">如您未满</span><span style="font-family: 宋体">18周岁，请您在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用国家开放大学出版社有限公司提供的服务。</span></p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">二、协议的接受与变更</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						><span style="font-family: 宋体">当您开始使用开放云书院平台服务或注册成为我们的用户时，您点击同意将视为您签署了本协议，表明您自愿接受本协议全部条款的约束，本协议将构成您与国家开放大学出版社有限公司（以下简称</span
						><span style="font-family: 宋体">“国家开放大学出版社”）及其搭建的开放云书院平台之间具有约束力的法律文件。</span></span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>考虑到互联网服务不断高速发展和演进，您同意国家开放大学出版社有权利对本协议进行修改，协议修改后，国家开放大学出版社将通过在相关页面公布修改的内容、通过您注册时提供的通讯工具发送或者其他任何合理方式通知您，您应该及时阅读修改后的协议。如果您不同意协议的修改，我们可能将无法为您提供协议修改所涉及的服务，您也可以选择停止使用；如果您选择在本协议修改后继续访问或使用本网站，则视为您已接受本协议的修改。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>您与国家开放大学出版社签署的本协议所列明的条款，并不能完全涵盖您与国家开放大学出版社所有的权利和义务。您同意国家开放大学出版社公布的其他协议、规则等（包括但不限于《开放云书院信息隐私保护政策》）将视为本协议之补充协议，为本协议不可分割的组成部分，与本协议具有同等法律效力。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">开放云书院及其关联公司可以根据组织架构、相关资质选择符合行业规范、技术标准和内部合规要求的技术或者商业服务商，为您提供技术服务、推广服务等多方面的服务。您知晓并同意接受相关服务，将被视作接受相关主体权利义务关系受本协议约束。</span>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">三、服务的内容与方式</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"><span style="font-family: 宋体">开放云书院平台提供服务的方式主要为：搭建</span><span style="font-family: 宋体">“开放云书院”移动客户端，为用户学习、下载在线学习内容提供平台；且通过不同的渠道，为用户提供在线学习内容。</span></span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">您知悉并同意，基于维护网络服务安全并不断提升用户体验和产品</span
					><span style="font-family: 宋体"
						>/服务性能的目的，开放云书院将不定期提供软件及相关服务范围的更新或改变（包括但不限于软件修改、版本升级、新服务开发与迭代、部分功能替换和下架等），您可以自行选择是否进行全部或者部分更新，但请您注意，具体服务或功能以开放云书院实际提供为准，且您拒绝全部或者部分更新的操作将导致部分功能受限或者不可使用。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>基于用户需求变化，国家开放大学出版社可能会不时修改、中断或终止无偿提供的服务，我们可能视情况不会通知您且不承担相应责任；若服务变更影响您与国家开放大学出版社之间的有偿服务，出版社将在事先通知您（包括站内消息或者平台公告的方式）的情况下予以修改或中断。基于服务变更或终止带来的影响和后续事宜，您同意我们将按照公平公正、诚实信用、等价有偿的原则与您协商处理。</span
					>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">四、账户的取得、使用及注销</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">请您确认，在您开始注册开放云书院平台用户前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的相应法律后果。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>a)账户开通方式：用户可线上自主注册两类账户，包括个人账户及企业账户，其中后者为企业管理员账户。如您是个人用户，可通过手机信息等方式自主注册并开通账户；如您是企业用户，可在开放云书院PC端注册并开通账户，或在手机客户端自主注册、线下客服开通账户。如您在注册时有疑问，也可在注册账户时线下咨询客服，由客服在后台开通企业账户并给到用户。用户对由此用户名和密码登入系统后所发生的所有活动和事件负责，并承担由此产生的直接或者间接法律责任，国家开放大学出版社不承担任何责任。此外，当有证据证明或者合理理由认为您的账</span
					><span style="font-family: 宋体">号存在安全风险时，出版社有权自行暂停或者为风险账号继续提供服务。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">b)开放云书院用户</span><span style="font-family: 宋体">账</span><span style="font-family: 宋体">号的所有权归属国家开放大学出版社，用户完成注册手续后，获得开放云书院用户</span><span style="font-family: 宋体">账</span
					><span style="font-family: 宋体"
						>号的使用权。用户应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，开放云书院不负任何责任。如果因注册信息不真实或更新不及时而引发的相关问题，开放云书院不负任何责任。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>c)用户应当通过真实身份信息认证注册账号，且用户提交的账号名称、头像和简介等注册信息中不得出现违法和不良信息，经开放云书院审核，如存在上述情况，开放云书院将不予注册；同时，在注册后，如发现用户以虚假信息骗取账号名称注册，或其账号头像、简介等注册信息存在违法和不良信息的，开放云书院有权不经通知单方采取限期改正、暂停使用、注销登记、收回等措施。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">d)用户有权注销其账户，当用户需要注销账户时，可自行根据开放云书院相关平台“帮助与反馈”一栏的规定操作注销流程。用户的账户一旦被注销后将造成用户无法继续学习该账户项下已购买的付费内容和有权限学习的在线资源的内容或上传内容等，注销账户的一切后果由用户自行承担。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>国家开放大学出版社为您提供账号注册途径，并享有注册账号的所有权，您可以通过注册账号使用并接受服务。您的账号及关联权益仅限您个人使用，未经国家开放大学出版社书面同意，您不得以任何形式赠与、转让、出借、售卖或是以类似方式许可他人使用您的账号及关联权益。您可以在注册并登录后，根据平台的规定订阅付费服务，包括但不限于付费资源包、</span
					><span style="font-family: 宋体">VIP会员和其他可通过付费购买的服务等。超过上述范围使用的，或者我们发现您可能存在上述违规分享账户权益的行为，都将视为您单方违约，国家开放大学出版社有权及时中止或终止对您的服务或取消VIP会</span
					><span style="font-family: 宋体">员资格，并可能进一步追究您的法律责任，您应自行承担超范围使用而导致的任何损失。</span>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">五、用户的基本权利</span>
				</h2>
				<p style="text-indent: 28px"><span style="font-family: 宋体">a)个人用户在开放云书院平台注册后可享受的功能及服务为：学习课程</span><span style="font-family: 宋体">，阅读数字图书。</span><span style="font-family: 宋体">&nbsp;</span></p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">b)企业用户在开放云书院平台注册后可享受的功能及服务为：添加组织架构及员工；对员工做离职、账户禁用处理；购买会员包并分配给员工；创建内部课程；使用内部学习工具。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>上述功能以及服务的具体内容由开放云书院根据实际情况提供。除非本服务协议另有其它明示规定，开放云书院所推出的新产品、新功能、新服务，均受到本服务协议之规范。如用户使用开放云书院提供的产品功能，自行制作并发布相关课程内容后，有将其原创内容或取得合法授权的内容在开放云书院平台上转做付费项目的意向，需与出版社另签付费项目协议，并以另签的协议约定为准。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">请您理解，由于版权许可的地域限制，当您离开中国大陆地区（为本协议之目的，不包含中国香港、中国澳门和中国台湾地区）使用本平台服务时，您可能无法访问由其他用户上传的音频作品内容，但已获得版权许可的部分作品除外。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">未经国家开放大学出版社或相关权利人书面同意，你不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</span>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">六、用户的基本义务与行为规范</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">用户承诺并保证遵守有关法律、法规、规章和主管部门规范性文件的规定。在任何情况下，国家开放大学出版社合理地认为用户存在违反上述规定的情况，有权不经事先通知终止向该用户提供服务。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>用户承诺并保证，用户在平台上传的文字、图片、视频、音频、多媒体资料或其他内容拥有相应合法的权利，不侵犯任何第三方的肖像权、名誉权、隐私权和知识产权（包括著作权、商标权、专利权和商业秘密等）和其他合法权利或权益；不违反用户与第三方所签订的对用户有约束力的法律文件的规定。国家开放大学出版社有权根据用户违反本协议的严重程度对用户采取警示整改、限制功能、暂停更新、关停账号等处置措施，并及时对发布的信息依法或依据本协议进行删除或屏蔽，根据法律要求保存记录并向有关主管部门报告。根据相关法律法规：</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"><br /></span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">1. 开放云书院禁止用户在平台上从事以下行为，损害国家或者社会公共利益：</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">a) 反对宪法确认的基本原则；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">b) 危害国家安全、泄露国家秘密的，颠覆国家政权，破坏国家统一；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">c) 损害国家荣誉和利益；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">d) 歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">e) 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">f) 煽动民族仇恨、民族歧视，破坏民族团结；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">g) 破坏国家宗教政策，宣扬邪教和封建迷信；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">h) 从事违法宗教活动，发布讲经讲道或者转发、链接相关内容，违规开展宗教教育培训，以宗教名义开展募捐，或以文字、图片、音视频等方式直播或者录播拜佛、烧香、受戒、诵经、礼拜、弥撒、受洗等宗教活动；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">i) 散布谣言，扰乱经济秩序和社会秩序；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">j)宣扬、散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">k)法律、行政法规禁止的其他内容。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"><br /></span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">2.国家开放大学出版社禁止用户利用本平台，非法从事以下行为、损害他人的合法权利或者权益：</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">a) 侮辱、诽谤他人，散布谣言等侵犯他人名誉、肖像等合法人格权益等；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">b) 对他人进行言语或者暴力威胁、恐吓，实施人肉搜索或者未经他人同意私自录制、散布和传播涉及他人个人资料等侵犯隐私的类似行为；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">c) 通过发布、删除信息或者其他干预信息呈现的手段，侵害他人知识产权等合法权益；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">d) 侵害未成年人身心健康及相关合法权益。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"><br /></span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">3. 开放云书院禁止用户利用平台及相关服务从事任何危害网络安全行为、损害公司合法利益，包括但不限于：</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">a) 伪造标题或以其他方式操控识别资料，使人误认为该内容为国家开放大学出版社所传送的。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">b) 将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">c) 以技术方式攻击或破坏或改变平台的部分或全部、或干扰其运行；以非法方式获取或使用平台的任何软件、代码或其他技术或商业信息；禁止用户对平台运行的任何程序进行反向工程、反向编译、反向汇编或改写。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">d) 未经许可使用平台的网站名称、公司名称、商标、商业标识、网页版式或内容、或其他由国家开放大学出版社或平台享有知识产权或权利的信息或资料；将平台以任何形式作为从事各种非法活动的场所、平台或媒介。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">e) 未经国家开放大学出版社书面许可、另行签署协议或另行指定可供用户使用的特定商业服务外，用户不得以商业目的使用平台；不对平台的任何部分或全部进行商业性质利用、复制、拷贝、出售、调查、广告。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">f) 未经国家开放大学出版社书面许可、另行签署协议或另行指定可供用户使用的特定商业服务外，用户不得通过平台发布有关任意第三方的广告宣传内容。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">g) 利用深度学习、虚拟现实等新技术新应用制作、发布和传播虚假消息，或者在发布和传播利用基于深度学习、虚拟现实等的新技术新应用制作的非真实音视频信息时，未以显著方式告知开放云书院并予以标识。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">h) 通过人工方式或者技术手段实施流量造假、流量劫持以及虚假注册账号、非法交易账号、操纵用户账号等行为，破坏网络生态秩序；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">i) 利用党旗、党徽、国旗、国徽、国歌等代表党和国家形象的标识及内容，或者借国家重大活动、重大纪念日和国家机关及其工作人员名义等，违法违规开展网络商业营销活动；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>用户就在平台上从事的个人行为承担全部法律责任。因用户违反法律规定或本协议规定造成违约、侵犯第三方合法权益、违反社会治安或者行政管理乃至涉嫌犯罪的，由用户自行承担相应的民事、行政和刑事法律责任。如果给国家开放大学出版社或平台造成损失，出版社有权向用户追偿其因此所遭受的全部损失、包括其直接损失、间接损失、预期利益损失等损失。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"><br /></span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">4.开放云书院平台鼓励用户从事以下行为：</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">a) 宣传习近平新时代中国特色社会主义思想，全面准确生动解读中国特色社会主义道路、理论、制度、文化的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">b) 宣传党的理论路线方针政策和中央重大决策部署的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">c) 展示经济社会发展亮点，反映人民群众伟大奋斗和火热生活的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">d) 弘扬社会主义核心价值观，宣传优秀道德文化和时代精神，充分展现中华民族昂扬向上精神风貌的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">e) 有效回应社会关切，解疑释惑，析事明理，有助于引导群众形成共识的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">f) 有助于提高中华文化国际影响力，向世界展现真实立体全面的中国的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">g) 其他讲品味讲格调讲责任、讴歌真善美、促进团结稳定等的内容。</span>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">七、用户产生的内容</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">用户在平台以各种形式发布的一切信息内容，均应符合国家法律法规等相关规定及网站相关规定，符合社会公序良俗，并不侵犯任何第三方主体的合法权益。根据法律法规要求，国家开放大学出版社将主动防范和抵制用户制作、复制、发布含有下列内容的不良信息：</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">a) 使用夸张标题，内容与标题严重不符的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">b) 炒作绯闻、丑闻、劣迹等的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">c) 不当评述自然灾害、重大事故等灾难的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">d) 带有性暗示、性挑逗等易使人产生性联想的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">e) 展现血腥、惊悚、残忍等致人身心不适的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">f) 煽动人群歧视、地域歧视等的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">g) 宣扬低俗、庸俗、媚俗内容的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">h) 可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">i) 其他违反法律、行政法规，可能对网络生态造成不良影响的内容。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>基于履行维护平台秩序和营造良好网络生态的法律义务，国家开放大学出版社有权随时检查您所上传的内容。如果发现您上传的内容不符合前述规定，国家开放大学出版社有权对用户上传的内容进行检查、编辑与修改；如经检查确认存在不宜传播或者其他违法违规信息，将依据法律规范采取包括禁言、封号等必要措施，由此带来的损失与不利影响由用户自行承担。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>但请您留意，其他用户通过平台而传播的内容，国家开放大学出版社不保证其合法性、正当性、准确性或完整性。您认可，在任何情况下平台均不承担真实性审查义务，国家开放大学出版社亦不对您主动发布的任何内容承担任何责任，包括但不限于由于任何内容而导致直接或间接损失。用户应自行承担因此产生的一切法律后果，且平台及国家开放大学出版社因此受到的损失，有权向用户追偿。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">开放云书院平台设立了公众投诉、举报平台，您可以按照《开放云书院举报受理和处置管理办法》或者平台上公示的投诉制度举报各类违法行为和不良信息。开放云书院将及时处理您的投诉、举报信息，履行营造良好网络空间生态的法律责任。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">此外，为提高您内容曝光量及发布效率，您同意您在开放云书院平台所发布的全部内容均授权国家开放大学出版社以您的账号自动同步发布至公司及</span
					><span style="font-family: 宋体"
						>/或关联方运营的其他软件及网站，您账号的头像、昵称等公开信息可能会一并同步。您在开放云书院平台上发布、修改、删除内容的操作，均会同步到上述其他软件及网站。您通过已注册或者已同步的账号登录公司及/或关联方运营的系列客户端产品、网站或者声联网设备时（如有），应遵守该产品、网站或声联网设备自身的用户协议及其他协议条款的规定。</span
					>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">八、用户个人信息保护</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">国家开放大学出版社高度重视保护您的个人信息，并依据《开放云书院信息隐私保护政策》收集、存储、使用、披露和采取合理措施保护用户个人信息安全。除法律法规规定的情形外，未经用户许可国家开放大学出版社不会向第三方公开、透露用户个人信息。请用户完整阅读前述隐私政策。</span>
				</p>
				<p style="text-indent: 28px"><span style="font-family: 宋体">出版社亦非常重视对未成年人个人信息的保护。若您是</span><span style="font-family: 宋体">18周岁以下的未成年人，在使用平台的服务前，应事先告知您的家长或法定监护人阅读并同意《开放云书院信息隐私保护政策》。</span></p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">九、知识产权与相应权益归属与授权</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">1. 公司享有的知识产权及相应权益</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>开放云书院及关联公司是本平台的开发与技术运营商，对平台服务及本平台所开发、运营的应用程序、网站和软件中所包含的全部数据、算法和资料等享有法定权利或权益，本平台整体内容的知识产权归国家开放大学出版社所有。本平台所有设计图样以及其他图样、产品及服务名称、商标、商号等，均为国家开放大学出版社所享有，任何人未经开放云书院及关联公司书面授权，不得使用、复制或用作其他商业或非商业用途。本平台授予用户就所开发和运营的软件以一项全球范围内的、非独占或排他的使用权，且用户不得自行或许可任何第三方复制、修改、出售或衍生产品。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">出版社对其平台上自主发布的专有内容、原创内容和其他通过授权取得的独占或者独家内容享有完整的知识产权。未经国家开放大学出版社书面许可，任何单位和个人不得私自转载、传播和提供收听服务或者有其他侵犯国家开放大学出版社知识产权的行为。否则，出版社将依法追究其法律责任。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">2. 用户的知识产权及相应权益</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">除非国家开放大学出版社收到相反通知或者存在足够的相反证明，国家开放大学出版社将用户视为其在平台上载或发布的内容的知识产权所有人。用户应对其在开放云书院平台上发布上传的内容（包括但不限于文字、图片、音视频等）享有知识产权或者合法授权，由此用户可以行使其相应的知识产权。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">您同意，您通过本协议将授予开放云书院及关联公司一项全球范围内无偿的、非独占、可再许可的使用权，包括但不限于复制权、翻译权、汇编权、信息网络传播权、改编权及制作衍生品、表演和展示的权利等。开放云书院及其关联公司有权通过开放云书院网</span
					><span style="font-family: 宋体">&nbsp;(ysy.crtvup.com.cn)、“开放云书院”移动客户端对前述内容进行复制、下载、编辑、修改、展示及网络传播。您同时许可开放云书院及其关联公司有权就因遭受侵权而单独提起诉讼，并获得相应赔偿。本协议已经构成《中华人民共和国著作权法》第二十五条所规定的书面协议，其适用于用</span
					><span style="font-family: 宋体">户在平台发布的任何受著作权法保护的内容，且效力及于本协议发布前的行为或内容。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>此外，经由本平台传送的内容，包括但不限于文字、图片、音频、视频及其他内容，受到《著作权法》《商标法》《专利法》及相关法律的保护；除该文字、图片、音频、视频及其他内容的上载用户所享有权利外，未经国家开放大学出版社书面许可，用户不得进行复制、修改、出租、转让、许可他人转让或衍生其他作品。</span
					>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">十、免责说明</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">国家开放大学出版社作为网络服务提供者，无法确保网站平台上的信息及服务能充分满足用户的需求。用户在接受平台服务的过程中，可能遇到错误、侮辱、诽谤、不作为、淫秽、色情或亵渎事件造成相关权益受损，国家开放大学出版社因事前无法知情而不承担法律责任。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>基于互联网的特殊性，平台也无法确保服务不会中断，对服务的及时性、安全性不作担保，不承担非因平台导致的责任。因开放云书院系统维护升级、第三方以及因不可抗力（不能预见、不能克服并不能避免的客观事件，如电信通讯故障、黑客攻击、政府管制）等情况导致的损失，公司不承担责任，但将尽合理努力及时配合修复并减小损失。国家开放大学出版社力图使用户能对本网站进行安全访问和使用，但国家开放大学出版社无法保证本平台或服务器是不含病毒或其它潜在有害因素的，建议用户应使用业界公认的软件查杀任何自平台下载文件中的病毒。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>除非国家开放大学出版社以书面形式明确约定，国家开放大学出版社对于用户以任何方式（包括但不限于包含、经由、连接或下载）从本平台所获得的任何内容信息，包括但不限于音频内容、广告内容、其他用户信息、商户信息、用户评价内容等，不保证其准确性、完整性、可靠性；对于用户因自身原因误解或错信本平台上的内容信息而购买、获取的任何产品、服务、信息或资料，国家开放大学出版社不承担责任。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">平台内所有用户所上传的声音、资源包等内容，仅代表用户个人观点，并不表示本网站赞同其观点或证实其描述，本平台不承担用户上传的内容引发的任何法律责任。国家开放大学出版社有权删除平台内各类不符合法律或协议规定的内容，而保留不通知用户的权利。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">所有发给用户的通告，平台都将通过正式的页面公告或站内信或电子邮件或客服电话或手机短信或常规的信件送达。请您提高防欺诈的辨别能力，任何非经平台正规渠道获得的活动或信息，开放云书院及其关联公司不承担法律责任。</span>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">十一、第三方链接</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">国家开放大学出版社可能会提供以合法方式获得的第三方网站或信息资源链接，除非另有声明外，国家开放大学出版社无法对第三方服务进行控制，因此由于下载、传播、使用或依赖上述网站或资源所产生的损失或损害，国家开放大学出版社不承担任何责任。</span>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">十二、侵权投诉与不侵权声明</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">当任何第三方认为用户利用开放云书院平台侵害其民事权益或实施侵权行为的，被侵权人均有权书面通知国家开放大学出版社采取删除、屏蔽、断开链接等必要措施。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">任何第三方认为，平台所涉及的文档、资源包、录音录像制品，侵犯自己的合法权益的，可以向平台提交书面通知，要求平台删除该侵权作品，或者断开链接。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">根据相关规定，侵权投诉需包含下述信息：</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">1）被侵权人的有效权利证明材料，或被侵权作品的原始链接及其它证明材料；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">2）侵权信息或作品在平台上的具体名称及链接；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">3）侵权投诉人的联络方式，以便平台及时与您取得联系，包括电子邮件地址、电话号码或手机等；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">4）投诉内容须纳入以下声明：“本人本着诚信原则，有证据认为该对象侵害本人的合法权益。本人承诺全部投诉信息真实、准确，自愿承担一切后果。”以及本人亲笔签字并注明日期，如代理他人投诉的，必须出具授权人签字的授权书。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">如无法同时具备上述信息，导致国家开放大学出版社无法判断是否存在侵权行为的，将可能因被我们视为不合格通知而被退回，您可以在规定时限内重新提交材料，因您怠于主张权利而遭受的扩大损失，由您个人承担。投诉人应当对侵权通知的真实性负责，如果侵权投诉不实，则需承担相应的法律责任。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>当您发布上传于开放云书院平台的内容被任何第三方向我们投诉涉嫌侵权，我们会将投诉人合格的侵权通知转送给您，您可以在一定期限内向我们提交不存在侵权行为的声明。声明应当包括不存在侵权行为的初步证据和您的真实身份信息。否则，我们将有权对您上传的内容采取删除、屏蔽、断开链接等必要措施，并且不承担由此可能给您带来的损失。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">根据相关规定，不侵权声明至少需包括以下信息：</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">1）被投诉人的真实身份信息，包括您的姓名（名称）、联系方式、地址、身份证等能够证明您真实身份的材料；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">2）侵权信息或作品在平台上的具体名称及链接；</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>3）不构成侵权的初步证明材料，包括但不限于权属证明（如有权机构颁发的版权证书、商标权证书、专利权证书）、授权证明、作品首次公开发表或发行日期证明材料、创作手稿、经权威机构签发的作品创作时间戳、作品备案证书等能证明被投诉方拥有相关权利的有效权属证明等不存在侵权行为的初步证据；</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">4）声明真实性的书面保证，内容需包含：“本着诚信原则，本人在开放云书院平台发布上传的内容不存在侵害他人合法权益的行为。本人承诺全部声明信息真实、准确，自愿承担一切后果。”以及本人亲笔签字并注明日期。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>如无法同时具备上述信息，导致国家开放大学出版社无法判断是否存在侵权行为的，将可能因被我们视为不合格声明而被退回，并保持此前已采取的必要措施。您可以在规定时限内重新提交声明。如您在规定期限内未重新提交，我们将可能判定您涉嫌侵权行为成立而永久对您的发布内容删除、屏蔽或者断开链接。因您怠于主张权利而遭受的扩大损失，由您个人承担。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">如您的不侵权声明经认定为符合上述要求，我们将会把您的声明及时转送给投诉人。请您留意，根据法律规定，我们仍可能保持对您涉嫌侵权内容删除、屏蔽或者断开链接状态，直至投诉人</span
					><span style="font-family: 宋体">15日内未向法院起诉或者有关主管部门投诉，并且我们将不对因我们履行法律义务而导致您的作品被删除、屏蔽或者断开链接所遭受的损失承担法律责任。</span>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">十三、平台广告与商业活动</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>您理解并接受，国家开放大学出版社及其关联公司为其平台的运营，可能进行下述商业活动：在经您明确表示同意后，通过电子邮件、客户端、网页或其他合法方式向您发送推广信息或其他相关商业信息。通过增值服务系统或其他方式向您发送相关服务信息或其他信息，其他信息包括但不限于通知信息、宣传信息、广告信息等。</span
					>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体"
						>您理解并接受，国家开放大学出版社为了平台的运营可在平台及相关服务中展示国家开放大学出版社、关联公司或第三方的商业、非商业信息（在开放云书院平台的任何位置，包括不限于在播放页贴片、播放页皮肤等位置发布前述信息）。开放云书院及其关联公司可以为您上传至平台的内容开通增值收益项目，包括但不限于打赏、广告等项目；您可以通过收益中心，申请就收益项目与平台分成；如果您无需就上述项目获得收益，可联系客服关闭收益分成。</span
					>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">十四、服务的终止</span>
				</h2>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">您理解并同意，基于经营策略的调整，或者基于可能出现的不可抗力因素，开放云书院可能会对服务内容进行变更，也可能会中断、中止或终止服务。</span>
				</p>
				<p style="text-indent: 28px"><span style="font-family: 宋体">您理解并同意，如您在使用开放云书院服务时存在违反法律法规、本协议及其他开放云书院规则、社会公德、公序良俗和</span><span style="font-family: 宋体">/或侵害他人合法权益等情形，开放云书院有权不经通知而单方中断或终止向您提供全部或部分服务。</span></p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">您理解并同意，如您实施违反法律法规、社会公德、公序良俗和</span><span style="font-family: 宋体">/或侵害他人合法权益等行为，并因此影响或可能影响国家开放大学出版社和/或他人的名誉、声誉或其他合法权益，开放云书院有权不经通知而单方中断或终止向您提供全部或部分服务。</span>
				</p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">开放云书院终止向您提供服务后，有权根据适用法律的要求删除您的个人信息，或使其匿名化处理，亦有权依照法律规定的期限和方式继续保存您留存于我方平台的其他内容和信息。</span>
				</p>
				<h2 style="margin: 20px 0;">
					<span style="font-family: 宋体; font-size: 16px; font-weight: 600;">十五、法律适用、管辖和其他</span>
				</h2>
				<p style="text-indent: 28px"><span style="font-family: 宋体">您可以通过以下方式与我们联系，我们将在</span><span style="font-family: 宋体">15个工作日内回复您的请求：</span></p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">如您对开放云书院用户服务协议有任何疑问、意见或建议，您可通过以下方式与我们取得联系：</span>
				</p>
				<p style="text-indent: 28px"><span style="font-family: 宋体">我方收件地址：北京市海淀区西四环中路</span><span style="font-family: 宋体">45号；</span></p>
				<p style="text-indent: 28px">
					<span style="font-family: 宋体">联系人：【开放云书院客服部】</span>
				</p>
				<p style="text-indent: 28px"><span style="font-family: 宋体">联系方式：【</span><span style="font-family: 宋体">010-6818-2532】</span></p>
				<p style="text-indent: 28px"><span style="font-family: 宋体">联系邮箱：【</span><span style="font-family: 宋体">service@crtvup.com.cn】</span></p>
				<p>
					<br />
				</p>
			</div>
      `,
    },
  },
  data() {
    return {}
  },
  components: {},
  watch: {},
  mounted() {},
  methods: {},
}
</script>

<style scoped lang="scss">
.page-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
}
</style>
